'use strict';

const { getFixedHeaderScrollOffset } = require('../utils/fixedHeaderScrollOffset');

/**
 * Syncs quantity value and package UI between buy-box and sticky bar inputs.
 * @param {jQuery} $source - quantity input that changed
 * @param {jQuery} $target - quantity input to mirror
 */
function syncQuantityInputs($source, $target) {
    if (!$source.length || !$target.length) return;

    $target.val($source.val());
    $target.attr({
        min: $source.attr('min'),
        max: $source.attr('max'),
        step: $source.attr('step')
    });
    $target.data('shipping-type', $source.data('shipping-type'));
    $target.data('package-quantities', $source.data('package-quantities'));
    $target.data('quantities', $source.data('quantities'));
    $target.data('package-unit-count', $source.data('package-unit-count'));
    $target.data('available-count', $source.data('available-count'));

    const $sourceWrapper = $source.closest('.quantity-wrapper');
    const $targetWrapper = $target.closest('.quantity-wrapper');

    $targetWrapper.toggleClass('quantity-wrapper--packages', $sourceWrapper.hasClass('quantity-wrapper--packages'));
    $targetWrapper.find('.js-quantity-sets-display').text($sourceWrapper.find('.js-quantity-sets-display').text());
    $targetWrapper.find('.js-quantity-package-hint').text($sourceWrapper.find('.js-quantity-package-hint').text());

    const $targetGroup = $target.closest('.quantity-input-group');
    const $sourceGroup = $source.closest('.quantity-input-group');

    $targetGroup.find('.quantity-btn--minus').prop('disabled', $sourceGroup.find('.quantity-btn--minus').prop('disabled'));
    $targetGroup.find('.quantity-btn--plus').prop('disabled', $sourceGroup.find('.quantity-btn--plus').prop('disabled'));
}

module.exports = {
    init: function () {
        const $bar = $('.pdp-sticky-buy-bar');
        const $buyButton = $('.pdp-layout__buybox .addToCartBlock button.add-to-cart').first();
        const $stickyBuyButton = $bar.find('button.add-to-cart').first();

        if (!$bar.length || !$buyButton.length || !$stickyBuyButton.length) return;

        const buyButtonEl = $buyButton.get(0);
        const footerEl = $('.footerMenu').closest('footer')[0] || $('.footerMenu')[0] || null;

        const updateVisibility = function () {
            const headerOffset = getFixedHeaderScrollOffset();
            const scrolledPast = buyButtonEl.getBoundingClientRect().bottom <= headerOffset;
            const footerOverlapping = footerEl && window.innerHeight > footerEl.getBoundingClientRect().top;
            const shouldShow = !$stickyBuyButton.prop('disabled') && scrolledPast && !footerOverlapping;

            $bar.toggleClass('is-visible', shouldShow);
            $bar.attr('aria-hidden', shouldShow ? 'false' : 'true');
            $('body').toggleClass('has-pdp-sticky-buy-bar', shouldShow);
        };

        $(window).on('scroll.pdpStickyBuyBar resize.pdpStickyBuyBar', updateVisibility).trigger('scroll');

        $(document).on('change', '.quantity-select', function () {
            const $changed = $(this);
            const $buyBoxQty = $('.pdp-layout__buybox .addToCartBlock .quantity-select').first();
            const $stickyQty = $bar.find('.quantity-select').first();

            if ($changed.closest('.pdp-sticky-buy-bar').length) {
                syncQuantityInputs($stickyQty, $buyBoxQty);
            } else if ($changed.closest('.pdp-layout__buybox').length) {
                syncQuantityInputs($buyBoxQty, $stickyQty);
            }
        });

        $('body').on('product:afterAttributeSelect', function (e, response) {
            const product = response.data && response.data.product;
            const $buyBoxQty = $('.pdp-layout__buybox .addToCartBlock .quantity-select').first();
            const $stickyQty = $bar.find('.quantity-select').first();

            syncQuantityInputs($buyBoxQty, $stickyQty);

            if (product) {
                const disabled = !product.purchasable || !product.readyToOrder || !product.available || !product.deliveryAvailable || !(product.price && product.price.available);

                $stickyBuyButton.attr('disabled', disabled);
            }

            updateVisibility();
        });
    }
};
